/**
 * views/index.js
 */
export {default as HomeView} from './home/HomeView';
export {default as EulaView} from './eula/EulaView';
